import React from "react";
import { useParams } from "react-router-dom";
import AzureMap from "components/AzureMap";
import "./Track.scss";
import TrackingEvent from "./TrackingEvent";
import { ConsignmentInformation } from "./ConsignmentInformation";
import { ConsignmentNotFound } from "./ConsignmentNotFound";
import { Header } from "./Header";
import { Loading } from "./Loading";
import { ContactInfo } from "./ContactInfo";
export const nullDatePrefix = "0001-01-01T";
const dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const monthOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];

export function getFriendlyDay(dateString) {
    var date = new Date(dateString);
    return `${dayOfWeek[date.getDay()]}, ${date.getDate()} ${monthOfYear[date.getMonth()]} ${date.getFullYear()}`;
}

export function Track() {
    const { trackingId } = useParams();
    const [notFound, setNotFound] = React.useState(false);
    const [consignment, setConsignment] = React.useState(undefined);
    const [error, setError] = React.useState(undefined);

    React.useEffect(() => {
        var url = `${window.location.origin.toString()}/api/tracking/${trackingId}`;
        fetch(url)
            .then((response) => {
                if (response.status === 404) {
                    setNotFound(true);
                }
                return response.json();
            })
            .then((responseJson) => {
                const parsed = JSON.parse(responseJson);
                setConsignment(Array.isArray(parsed) ? parsed[0] : parsed);
            })
            .catch((error) => {
                setError(error);
            });
    }, [trackingId]);

    if (notFound || error) {
        return (
            <ConsignmentNotFound message={notFound ? "Consignment not found" : "An error occurred, please try again"} />
        );
    }

    // Display this when no data is returned
    if (!consignment) {
        return <Loading />;
    }

    //console.log("DATA", consignment);

    return (
        <div className="Track d-flex flex-column flex-grow-1 h-100 py-4">
            <div className="container">
                <Header consignment={consignment} />

                <div className="row">
                    <div className="col-12 col-lg-6 text-white mb-5 pr-xl-5">
                        <div
                            className="w-100 rounded mb-5"
                            id="map"
                            style={{
                                height: "317px",
                                maxWidth: "778px",
                                overflow: "hidden",
                            }}
                        >
                            <AzureMap
                                className="rounded"
                                pickupAddress={consignment.pickupAddress}
                                deliveryAddress={consignment.deliveryAddress}
                            />
                        </div>
                        <ConsignmentInformation consignment={consignment} />
                    </div>

                    {/* PACKAGE EVENT DETAILS HERE */}
                    <div className="col-12 col-lg-6 pl-xl-5">
                        <p id="tracking-number" className="text-white text-uppercase text-center lead">
                            <span>Tracking #: </span>
                            <span className="font-weight-bold">{consignment.connoteNumber}</span>
                        </p>

                        <div className="mb-5">
                            <TrackingEvent
                                eventData={consignment.events?.find((event) => event.milestone === "Delivered")}
                            />
                            <TrackingEvent
                                eventData={consignment.events?.find(
                                    (event) => event.milestone === "On Board for Delivery"
                                )}
                            />
                            <TrackingEvent
                                eventData={consignment.events?.find(
                                    (event) => event.milestone === "In Transit" && event.title !== "Manifested"
                                )}
                            />
                            <TrackingEvent
                                eventData={consignment.events?.find(
                                    (event) => event.milestone === "Manifested" || event.title === "Manifested"
                                )}
                            />
                        </div>

                        <ContactInfo consignment={consignment} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Track;
